import { put, call, takeEvery, all } from 'redux-saga/effects'

import { FETCH_INDICES, ADD_INDEX, UPDATE_INDEX, REMOVE_INDEX } from '../actions/types'
import {
  fetchIndices,
  fetchIndicesSuccess,
  fetchIndicesFailure,
  addIndexSuccess,
  addIndexFailure,
  updateIndexSuccess,
  updateIndexFailure,
  removeIndexSuccess,
  removeIndexFailure,
} from '../actions/elasticIndicesActions'
import { fetchAliases } from '../actions/elasticAliasesActions'
import elasticService from '../services/elasticService'

function* handleFetchIndices(action) {
  try {
    const { accessToken } = action.payload

    // Fetch data from API
    const results = yield call(elasticService.fetchIndices, accessToken)

    yield put(fetchIndicesSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching elastic indices')
    yield put(fetchIndicesFailure(err))
  }
}

function* handleAddIndex(action) {
  try {
    const { indexName, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.addIndex, accessToken, indexName)

    // Broadcast success
    yield put(addIndexSuccess(action.payload))

    // Fetch new indices
    yield put(fetchIndices(accessToken))
  } catch (error) {
    console.error(error, 'Error adding elastic index')
    yield put(addIndexFailure({ error, ...action.payload }))
  }
}

function* handleUpdateIndex(action) {
  try {
    const { indexName, mapping, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.updateIndex, accessToken, indexName, mapping)

    // Broadcast success
    yield put(updateIndexSuccess(action.payload))

    // Fetch new indices
    yield put(fetchIndices(accessToken))
  } catch (error) {
    console.error(error, 'Error updating elastic index')
    yield put(updateIndexFailure({ error, ...action.payload }))
  }
}

function* handleRemoveIndex(action) {
  try {
    const { indexName, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.removeIndex, accessToken, indexName)

    // Broadcast success
    yield put(removeIndexSuccess(action.payload))

    // Fetch new indices
    yield put(fetchIndices(accessToken))

    // Fetch new aliases (deleting an index w/an alias will also delete the alias)
    yield put(fetchAliases())
  } catch (error) {
    console.error(error, 'Error removing elastic index')
    yield put(removeIndexFailure({ error, ...action.payload }))
  }
}

function* watchElasticIndicesSagas() {
  yield all([takeEvery(FETCH_INDICES, handleFetchIndices), takeEvery(ADD_INDEX, handleAddIndex), takeEvery(UPDATE_INDEX, handleUpdateIndex), takeEvery(REMOVE_INDEX, handleRemoveIndex)])
}

export default watchElasticIndicesSagas
